/**
 * Created by dannyr on 13/12/2016.
 */

import React from "react";
import type { WaSearchUrlTooltipContentProps } from "./WaSearchUrlTooltipContent";
import { WaSearchUrlTooltipContent } from "./WaSearchUrlTooltipContent";
import { PopupHoverContainer } from "@similarweb/ui-components";

interface WaSearchUrlTooltipProps extends WaSearchUrlTooltipContentProps {
    children: React.ReactNode;
}

export class WaSearchUrlTooltip extends React.Component<WaSearchUrlTooltipProps> {
    static defaultProps = { data: [] };

    render() {
        return (
            <PopupHoverContainer
                content={() => <WaSearchUrlTooltipContent data={this.props.data} />}
                config={{ enabled: true, placement: "left", allowHover: true, closeDelay: 100 }}
            >
                {this.props.children}
            </PopupHoverContainer>
        );
    }
}
